import { Component, OnInit } from '@angular/core';
import { ApplicationUsersComponent } from '@directory/components/application-users/application-users.component';
import { FormsModule } from '@angular/forms';
import {
  AsyncPipe,
  KeyValuePipe,
  NgClass,
  NgForOf,
  NgIf,
  NgSwitch,
  NgSwitchCase,
} from '@angular/common';
import { SimplebarAngularModule } from 'simplebar-angular';
import { TimeAgoPipe } from '@pipes/time-ago.pipe';
import { TemplateFormComponent } from '@components/template-form.component';
import { ofType } from '@ngrx/effects';
import { authenticationActions } from '@redux/authentication.redux';
import { User } from '@models/account/user.model';
import { takeUntil } from 'rxjs';
import { WrongResidentComponent } from '../../../authentication/components/wrong-resident/wrong-resident.component';
import { catalogActions, selectCatalog } from '@redux/catalog.redux';

@Component({
  selector: 'app-add-resident',
  standalone: true,
  imports: [
    ApplicationUsersComponent,
    FormsModule,
    KeyValuePipe,
    NgForOf,
    NgIf,
    SimplebarAngularModule,
    TimeAgoPipe,
    NgSwitchCase,
    NgSwitch,
    NgClass,
    AsyncPipe,
  ],
  templateUrl: './add-resident.component.html',
  styles: ``,
})
export class AddResidentComponent extends TemplateFormComponent implements OnInit {
  step = 0;
  info = 'Please enter the Family App code for this resident below.';
  error: string | null = null;
  lead: User | null = null;

  relationships$ = this.store.select(selectCatalog.selectRelationships);

  model: {
    code: string | null;
    relationshipId: string | null;
    residentUserId: string | null;
  } = {
    code: null,
    relationshipId: null,
    residentUserId: null,
  };

  ngOnInit(): void {
    this.subscriptions.push(
      this.actions$
        .pipe(ofType(authenticationActions.familyCodeSuccess), takeUntil(this.destroy$))
        .subscribe((action) => {
          this.error = null;
          this.lead = action.resident;
          this.model = {
            ...this.model,
            residentUserId: this.lead.id,
          };
          this.info = `You are being matched to resident ${this.lead.firstName} ${this.lead.lastName} at ${this.community?.name}`;
          this.step = 1;
          this.store.dispatch(catalogActions.relationships());
        }),

      this.actions$
        .pipe(ofType(authenticationActions.familyCodeFail), takeUntil(this.destroy$))
        .subscribe(({ error }) => {
          this.error = error;
        }),
      this.actions$
        .pipe(ofType(authenticationActions.linkRelativeResidentSuccess), takeUntil(this.destroy$))
        .subscribe(() => {
          this.notificationService.success(`Relation Registered.`);
          setTimeout(() => window.location.reload(), 1000);
        }),
    );
  }

  onCode() {
    const code = this.form.controls['code'];
    if (code && code.value) {
      this.store.dispatch(authenticationActions.familyCode({ code: code.value }));
    } else {
      this.notificationService.error(`Input code.`);
    }
  }

  onModal() {
    this.modal.hide();
    setTimeout(
      () =>
        this.modal.show(WrongResidentComponent, {
          backdrop: 'static',
          class: 'modal-dialog-centered',
        }),
      500,
    );
  }

  override ngSubmit(): void {
    this.store.dispatch(authenticationActions.linkRelativeResident({ model: this.model }));
  }
}
